import { useEffect, useState } from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import login from "../../../../src/assest/login.png";
import logo from "../../../../src/assest/logo.svg";
import "./index.css";
import MaterialTypography from "../../../components/MaterialTypography";
import PageLayout from "../../../layoutcontainers/PageLayout";
import MaterialInput from "../../../components/MaterialInput";

import { userLoginServices } from "../../../services/loginServices";
import { useSnackbar } from "../../../components/SnackbarProvider";
import { useLoading } from "../../../context/loadingcontext";

import { useAuth } from "../../../context/AuthContext";

function Signin() {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { circleLoading, setCirleLoading } = useLoading();
  const { setAuthenticated } = useAuth();

  const [signInData, setSignInData] = useState({
    email: "",
    password: null,
    emailStatus: "unchecked",
    passwordStatus: "unchecked",
  });
  useEffect(() => {}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedData = { ...signInData };

    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    switch (name) {
      case "email":
        updatedData.email = value;
        updatedData.emailStatus = validateEmail(value) ? "success" : "error";
        break;

      case "password":
        updatedData.password = value;
        updatedData.passwordStatus = "success";
        break;

      default:
        break;
    }

    setSignInData(updatedData);
  };

  const submitHandle = async () => {
    const { success, message, data } = await userLoginServices(
      signInData?.email,
      signInData?.password
    );
    showSnackbar(message, success);
    if (success) {
      navigate("/insurance");
      showSnackbar(message, "success");
      setAuthenticated(true);
      localStorage.setItem("authenticated", JSON.stringify(true));
    } else {
      showSnackbar(message, "error");
      setAuthenticated(false);
      localStorage.setItem("authenticated", JSON.stringify(false));
    }
  };

  return (
    <PageLayout background="white" height="100%" showNavbar disableFooter>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          overflow: "hidden",
          fontFamily: "Nunito Sans",
        }}
      >
        <Box sx={{ width: "50%", height: "100%" }}>
          <img
            src={login}
            alt="login img"
            width="100%"
            height="100%"
            style={{ objectFit: "cover" }}
          />
        </Box>
        <Box
          sx={{
            width: "50%",
            height: "100%",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <img
              src={logo}
              alt="Logo"
              style={{ width: "240px", marginTop: "40px" }}
            />
            <Box sx={{ padding: "0px 30px" }}>
              <Typography
                sx={{
                  fontFamily: "Nunito Sans",
                  fontWeight: 400,
                  fontSize: "15px",
                  lineHeight: "22.91px",
                  color: "#BCB2B2",
                  padding: "5px 20px",
                }}
              >
                Access Your Insurance Agent Portal Handle policies, view
                earnings, and serve your clients efficiently from one secure
                dashboard.
              </Typography>
            </Box>
            <Box
              sx={{
                textAlign: "start",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "350px" }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontFamily: "Nunito Sans",
                    fontWeight: 700,
                    color: "#04324D",
                    fontSize: "30px",
                  }}
                  mt={2}
                >
                  Login to your Account
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "13px",
                    fontFamily: "Nunito Sans",
                  }}
                >
                  See what is going on with your business
                </Typography>

                <MaterialTypography
                  sx={{ marginTop: "20px" }}
                  variant="caption"
                  color="text"
                >
                  Email
                </MaterialTypography>
                <MaterialInput
                  type="email"
                  name="email"
                  placeholder="mail@abc.com"
                  value={signInData.email}
                  onChange={handleChange}
                  error={signInData.emailStatus === "error"}
                  helperText={
                    signInData.emailStatus === "error"
                      ? "Please enter a valid email address"
                      : ""
                  }
                />
                <MaterialTypography
                  sx={{ marginTop: "20px" }}
                  variant="caption"
                  color="text"
                >
                  Password
                </MaterialTypography>
                <MaterialInput
                  type="password"
                  name="password"
                  placeholder="***************"
                  value={signInData.password}
                  onChange={handleChange}
                  error={signInData.passwordStatus === "error"}
                  helperText={
                    signInData.passwordStatus === "error"
                      ? "Password must contain at least 8 characters, including uppercase, lowercase, number, and special character."
                      : ""
                  }
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "20px",
                  }}
                >
                  <Box sx={{ marginLeft: "6px", color: "#00AA1C" }}>
                    <FormControlLabel
                      control={<Checkbox size="small" color="#00AA1C" />}
                      label="Remember Me"
                    />
                  </Box>
                  <Typography
                    sx={{ color: "#00AA1C", fontSize: "16px" }}
                  ></Typography>
                </div>

                <button
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "none",
                    color: "white",
                    background: "#00AA1C",
                    borderRadius: "6px",
                    fontSize: "18px",
                    marginTop: "5px",
                  }}
                  onClick={() => submitHandle()}
                >
                  Login
                </button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
}

export default Signin;
